import __vue_component__ from '../HseIcon/HseIcon.vue.js';
import { getClickableIconColorStyles } from '@hse-design/core';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=2467%3A37
 * @storybook /?path=/story/icons-clickableicon--playground
 * @react /src-components-clickable-icon
 * @reactStorybook /?path=/story/icons-clickableicon--playground
 */
var script = {
  name: 'HseClickableIcon',
  components: {
    HseIcon: __vue_component__
  },
  props: {
    /**
     * Компонент
     */
    component: {
      type: [String, Object, Function],
      default: 'button'
    },
    /**
     * Размер иконки
     * @values small, medium, large
     */
    size: {
      type: String,
      default: 'small'
    },
    /**
     * Компонент иконки
     */
    icon: {
      type: [Object, String],
      default: null
    },
    /**
     * Отключенное состояние
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * hover состояние
     */
    hovered: {
      type: Boolean,
      default: false
    },
    /**
     * Сфокусированное состояние
     */
    focused: {
      type: Boolean,
      default: false
    },
    /**
     * Стиль иконки
     */
    iconStyle: {
      type: [String, Object, Array],
      default: ''
    },
    /**
     * Цвет иконки
     */
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        click: (e) => {
          if (!this.disabled) this.$emit('click', e);
        }
      }
    },
    iconStyleComputed() {
      const { iconStyle } = this;
      const colorStyle = getClickableIconColorStyles(this.color);

      if (Array.isArray(iconStyle)) {
        return [...iconStyle, colorStyle];
      }

      if (typeof iconStyle === 'object') {
        return { ...iconStyle, ...colorStyle };
      }

      if (typeof iconStyle === 'string' && iconStyle.trim().length) {
        return `${iconStyle}; ${Object.keys(colorStyle).map(s => `${s}: ${colorStyle[s]}`).join('; ')}`;
      }

      return colorStyle;
    },
    componentProps() {
      const { component } = this;
      return component === 'button'
        ? {
          disabled: this.disabled,
          type: component === 'button' ? 'button' : undefined
        }
        : this.$attrs;
    }
  }
};

export default script;
